module.exports = __webpack_public_path__ + "static/media/notebook04.8d67e345.jpg";